import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
import Admin from '../pages/Admin';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />

    <Route path="/admin" component={Admin} isPrivate />
  </Switch>
);

export default Routes;
